import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class DispatchAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getDispatchById(dispatchId,router) {
    const url = `/api/dispatch/${dispatchId}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getFlightLegsById(dispatchId, router) {
    const url = `/api/dispatch/flightlegs/${dispatchId}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getDataByDispatchId(dispatchId, router) {
    const url = `/api/dispatch/data/${dispatchId}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  create(params, router) {
    const url = "/api/dispatch/";
    return this.CommonAPIService.postCall(url, params, router);
  }

  createFlightLegs(params, router) {
    const url = "/api/dispatch/flightlegs";
    return this.CommonAPIService.postCall(url, params, router);
  }

  createWeightBalance(dispatchId,params, router) {
    const url = `/api/dispatch/weightbalance/${dispatchId}`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  createFlightDetails(dispatchId,params, router) {
    const url = `/api/dispatch/flightdetails/${dispatchId}`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  createPilotReadiness(params, router) {
    const url = "/api/dispatch/pilotreadiness";
    return this.CommonAPIService.postCall(url, params, router);
  }

  createAircraftAirworthiness(params, router) {
    const url = "/api/dispatch/aircraftairworthiness";
    return this.CommonAPIService.postCall(url, params, router);
  }

  createPaveWorksheet(params, router) {
    const url = "/api/dispatch/paveworksheet";
    return this.CommonAPIService.postCall(url, params, router);
  }
}
export default DispatchAPIService;
